import {vars} from "@/shared/lib/theme.css";
import {CSSProperties} from "react";
import {GroupBase, OptionsOrGroups, Props} from "react-select";
import makeAnimated from "react-select/animated";
import CreatableSelect from "react-select/creatable";
import Column from "../Column";
import {label} from "./index.css";

const animatedComponents = makeAnimated();

type CreatableProps<Option> = {
	options: OptionsOrGroups<Option, GroupBase<Option>> | undefined;
	fullWidth?: boolean;
	labelText?: string;
	name?: string;
	containerStyle?: CSSProperties;
};

function Creatable<Option, IsMulti extends boolean, Group extends GroupBase<Option>>({
	options,
	fullWidth,
	labelText,
	name,
	isMulti,
	onChange,
	containerStyle,
	isDisabled,
	...rest
}: CreatableProps<Option> & Props<Option, IsMulti, Group>) {
	return (
		<Column
			fullWidth={fullWidth}
			style={{
				justifyContent: "flex-start",
				alignItems: "flex-start",
				gap: vars.size[8],
				...containerStyle
			}}
		>
			{labelText && (
				<label className={label()} htmlFor={name}>
					{labelText}
				</label>
			)}
			<CreatableSelect
				name={name}
				formatCreateLabel={(inputValue) => `새로운 취미: "${inputValue}"`}
				components={animatedComponents}
				options={options}
				isMulti={isMulti}
				placeholder="선택해주세요"
				isClearable
				isSearchable
				isDisabled={isDisabled}
				isLoading={false}
				closeMenuOnSelect={false}
				noOptionsMessage={() => "선택할 항목이 없습니다."}
				onChange={onChange}
				// isOptionDisabled={}
				// isOptionSelected={}
				// defaultMenuIsOpen={false}
				// menuIsOpen={false}
				styles={{
					container: (baseStyles) => ({
						...baseStyles,
						whiteSpace: "nowrap",
						width: fullWidth ? "100%" : "auto"
					}),
					control: (baseStyles) => ({
						...baseStyles,
						width: "100%",
						borderWidth: 0.5,
						borderColor: vars.color.gray[200],
						borderStyle: "solid",
						borderRadius: vars.border.small,
						backgroundColor: isDisabled ? vars.color.gray[50] : vars.color.white,
						paddingBlock: 2,
						paddingInline: vars.size[4]
					}),
					placeholder: (baseStyles) => ({
						...baseStyles,
						width: "100%",
						fontSize: vars.size[14],
						color: vars.color.gray[400]
					}),
					input: (baseStyles) => ({
						...baseStyles,
						fontSize: vars.size[14],
						color: vars.color.black
					}),
					valueContainer: (baseStyles) => ({
						...baseStyles
					}),
					singleValue: (baseStyles) => ({
						...baseStyles,
						fontSize: vars.size[14]
					}),
					multiValueLabel: (baseStyles) => ({
						...baseStyles,
						fontSize: vars.size[12],
						color: vars.color.white
					}),
					multiValue: (baseStyles) => ({
						...baseStyles,
						backgroundColor: vars.color.main[2],
						borderRadius: vars.border.extraSmall
					}),
					multiValueRemove: (baseStyles) => ({
						...baseStyles,
						fontSize: vars.size[14],
						color: vars.color.white
					}),
					menuPortal: (baseStyle) => ({
						...baseStyle,
						padding: 0
					}),
					menu: (baseStyle) => ({
						...baseStyle,
						borderRadius: vars.border.small,
						zIndex: 1000
					}),
					option: (baseStyle) => ({
						...baseStyle,
						fontSize: vars.size[14],
						paddingBlock: vars.size[12],
						paddingInline: vars.size[16]
					}),
					group: (baseStyle) => ({
						...baseStyle,
						padding: 0
					}),
					groupHeading: (baseStyle) => ({
						...baseStyle,
						fontSize: vars.size[12],
						color: vars.color.white,
						backgroundColor: vars.color.gray[600],
						paddingBlock: vars.size[8],
						paddingInline: vars.size[20]
					})
				}}
				{...rest}
			/>
		</Column>
	);
}

export default Creatable;
